/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpCategoryDeleteSubCategoryResponse } from './CarpCategoryDeleteSubCategoryResponse';

export type CarpCategoryDeleteSubCategoryResponseApiRespoonse = {
    data?: CarpCategoryDeleteSubCategoryResponse;
    status?: CarpCategoryDeleteSubCategoryResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpCategoryDeleteSubCategoryResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

